export const translations = {
  RESEND_EMAIL_FAMILY_MODAL: {
    description: 'Family member resend email text',
    primaryValue: 'Resend Email',
    stringKey: 'RESEND_EMAIL_FAMILY_MODAL',
  },
  RESEND_EMAIL_FAMILY_MODAL_BUTTON: {
    description: 'Family member resend text',
    primaryValue: 'Resend',
    stringKey: 'RESEND_EMAIL_FAMILY_MODAL_BUTTON',
  },
  FAMILY_EMAIL_PLACEHOLDER: {
    description: 'Family member email placeholder',
    primaryValue: 'Enter email address',
    stringKey: 'FAMILY_EMAIL_PLACEHOLDER',
  },
};

export default translations;
